import { render, staticRenderFns } from "./EvalModelsPage.vue?vue&type=template&id=514e9bb4"
import script from "./EvalModelsPage.vue?vue&type=script&lang=ts"
export * from "./EvalModelsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports